import React, { Component } from 'react';
import {StyleSheet, Text, View, Animated, Easing, Image, Pressable} from 'react-native';

import { Ionicons } from 'react-native-vector-icons';

import GameData from './GameData';
import TaskImages from './Images';
import TextReader from './TextReader';
import ProgressBar from './ProgressBar';

const fps = 10;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

class ActionRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //name: props.task.action.name,
      //countText: props.task.count.toString(),
      //ready: false,
      refresh: false,
    }
	this.name = props.task.action.name;
	this.isReady = false;
	this.countRef = React.createRef();
	this.countText = props.task.count.toString();
    this.taskNumber = props.taskCount+1;
    this.count = props.task.count;
	this.progressRef = React.createRef();
    this.progressAnim = new Animated.Value(0);
	this.progressInterpolate =
    this.progressAnim.interpolate({
      inputRange: [0, 1],
      outputRange: ["0%", "100%"]
    });
    this.doneActions = 0;
    this.progressPercent = 0;
    this.started = false;

    this.id = this.props.task.id;
	this.timeout = null;
	
	setTimeout(function(){
        this.updateBarEstimate();
	  }.bind(this),1);
  }
	
	
    shouldComponentUpdate(nextProps, nextState) {
    // Rendering the component only if 
    // passed props value is changed
	
	if (this.highlight === true && this.taskNumber !== GameData.codeIndex) {
		this.highlight = false;
		return true;
    }
  
    if (nextProps.value !== this.props.value) {
      return true;
    }
    if (nextState !== this.state) {
      return true;
    }
    return false;
  }
  
  updateBarEstimate() {
	  if (GameData.assistance && this.progressRef.current) {
		this.progressRef.current.set(GameData.getMyEstimate(this.taskNumber));
		//this.setState({refresh: !this.state.refresh});
		this.props.updateRest(this.taskNumber);
	  }
  }

  updateCount(count) {
    this.count = count;
    //this.setState({countText: this.count.toString()});
	this.countText = this.count.toString();
	this.countRef.current.changeText(this.countText);
  }

  ready() {
	  this.isReady = true;
	  if (this.progressRef.current) {
		this.progressRef.current.set(0);
	  }
    this.setState({refresh: !this.state.refresh});
  }

  unready() {
	  this.isReady = false;
	  this.progressRef.current.set(0);
    this.setState({refresh: !this.state.refresh});
  }

  refresh() {
	  //console.log(this.countRef);
	  
    //this.setState({countText: this.props.task.count.toString()});
	this.countText = this.props.task.count.toString();
	this.countRef.current.changeText(this.countText);
    //this.progressAnim.setValue(0);
    this.progressRef.current.set(0);
	this.doneActions = 0;
    this.progressPercent = 0;
    this.started = false;
  }

  removeInterval() {
    clearInterval(this.interval);
  }

  componentWillUnmount() {
    if (this.interval) {
     clearInterval(this.interval);
    }
  }

  fastIncrement() {
    this.interval = setInterval(function() {
      for (let i = 0; i < 10; i++) {
        this.increment();
      }
    }.bind(this), 200);
  }

  increment() {
    //if (!GameData.canIncremenet(this.props.task.action)) {
      //return;
    //
    
    if (!GameData.canIncremenet(this.props.task.action)) {
      return false;
    }

    GameData.code[this.taskNumber-1].count += 1;
    this.count += 1;
    //this.setState({countText: this.count.toString()});
	this.countText = this.count.toString()
	this.countRef.current.changeText(this.countText);
	
		this.updateBarEstimate();
  }

  fastDecrement() {
    this.interval = setInterval(function() {
      for (let i = 0; i < 10; i++) {
        this.decrement();
      }
    }.bind(this), 200);
  }

  decrement() {
    if (this.count == 0) {
      return;
    }
    this.count -= 1;
    if (this.count == 0) {
      this.props.remove(this.taskNumber);
    }
    else {
      GameData.code[this.taskNumber-1].count -= 1;
      //this.setState({countText: this.count.toString()});
	  this.countText = this.count.toString();
	  this.countRef.current.changeText(this.countText);
	  
	  	this.updateBarEstimate();
    }
  }

  remove() {
    this.props.remove(this.taskNumber);
  }
  
  stop() {
	   //this.progressAnim.stopAnimation();
	   this.progressRef.current.stop();
	   clearTimeout(this.timeout);
  }

  start() {
    GameData.code[this.taskNumber-1].timesDone = 0;
    this.started = true;
    //this.setState({countText: "0/" + this.count});
	this.countText = "0/" + this.count;
	this.countRef.current.changeText(this.countText);
    this.doneActions = 0;
    //this.progressAnim.setValue(0);
	this.progressRef.current.set(0);
    this.progressPercent = 0;
    this.progress();
  }

  restart() {
    
   // this.progressAnim.setValue(0);
	this.progressRef.current.set(0);
    this.progressPercent = 0;
    this.progress();
  }

  progress() {
    //let progress = this.calculateProgress();
    //this.progressPercent += progress;
    //let toValue = this.progressPercent;
    let toValue = 1;

    //let schemeDuration = fpsDuration;
    let schemeDuration = this.getTime() * 1000;
	
    /*
    if (1-toValue < MYEPSILON) {
      let extraPercent = Math.max(toValue-1, 0) / progress;
      schemeDuration *= 1-extraPercent;

      toValue = 1;
    }
    */
	
	//let threat = GameData.getThreat(this.props.task.action)*schemeDuration/1000;
	
	let threat = GameData.getThreat(this.props.task.action, schemeDuration/1000);
	
	let bonusThreat = 0;
	
	if (this.props.task.action.completion.threat) {
		bonusThreat = this.props.task.action.completion.threat;
	}

    let threatResults = this.props.raiseThreat(threat, schemeDuration, bonusThreat);
    if (threatResults.end) {
      toValue = threatResults.time / schemeDuration;
      //if (1-toValue < MYEPSILON) {
        //toValue = 1;
      //}
      schemeDuration = threatResults.time;
    }
    
	/*
    Animated.timing(this.progressAnim, {
      toValue: toValue,
      easing: Easing.linear,
      duration: schemeDuration,
      useNativeDriver: false,
    }).start();
	*/
	
	this.progressRef.current.start(toValue, schemeDuration);
    

    let pause = false;
    let canContinue = false;
    if (threatResults.end) {
      if (1-toValue < MYEPSILON) {
        this.timeout = setTimeout(function() {
          this.doneActions += 1;
          GameData.code[this.taskNumber-1].timesDone += 1;
          //this.setState({countText: this.doneActions + "/" + this.count});
		  this.countText = this.doneActions + "/" + this.count;
		  this.countRef.current.changeText(this.countText);
          pause = this.props.complete(this.props.task.action, this);
          canContinue = this.props.canContinue();
          if (!pause) { 
            if (canContinue) {
              if (this.doneActions < this.count) {
                  this.restart();
              }
              else {
                this.props.rise();
              }
            }
            else {
              this.props.finish();
            }        
          }

        }.bind(this), schemeDuration);
      }
      else {
        this.timeout = setTimeout(function() {
          pause = false; //this.props.complete(this.props.task.action, null, toValue);
          if (!pause) { 
            this.props.finish();
          }
        }.bind(this), schemeDuration);
      }
    }
    else {
    //if (1-toValue < MYEPSILON) {
    //if (toValue >= 1) {
    this.timeout = setTimeout(function() {
      this.doneActions += 1;
      GameData.code[this.taskNumber-1].timesDone += 1;
      //this.setState({countText: this.doneActions + "/" + this.count});
      this.countText = this.doneActions + "/" + this.count;
	  this.countRef.current.changeText(this.countText);
	  let pause = this.props.complete(this.props.task.action, this);
      if (!pause) {
        if (this.doneActions < this.count) {
            this.restart();
        }
        else {
          this.props.rise();
        }
      }
    }.bind(this), schemeDuration);
    /*
    else {
      setTimeout(function(){
        this.progress();
      }.bind(this), schemeDuration);
    }
  */
    }
  }

  resume() {
    if (this.doneActions < this.count) {
       this.restart();
    }
    else {
       this.props.rise();
    }
  }

  calculateProgress() {
    return fpsPecent / this.getTime();
  }

  // % modiifer = ((modifier - 1) * (%)) + 1
  getTime() {
	  return GameData.getTime(this.props.task.action)
  }

  updateCodeIndex() {
    this.props.setCodeIndex(this.taskNumber);
    this.setState({refresh: !this.state.refresh})
  }
  
  overlayInfo() {
	  this.props.overlayInfo();
  }

  render() {
    let rowStyle = styles.row;
	let progressStyle = styles.actionProgress;
    if (!this.isReady && this.taskNumber == GameData.codeIndex) {
		this.highlight = true;
		rowStyle = styles.highlightrow;
		progressStyle = styles.altActionProgress;
    }

    let addminus = null;
    if (!this.isReady) {
      if (!GameData.canIncremenet(this.props.task.action)) {
        addminus = <View style={styles.buttonrow}>
          <Pressable style={styles.addminusButton} onPress={this.remove.bind(this)}>
            <Ionicons
              name="md-close-outline"
              size={20}
              color={"#000000"}
            />
          </Pressable>
          </View>
      }
      else {
        addminus = <View style={styles.buttonrow}>
          <Pressable style={styles.addminusButton} onPress={this.increment.bind(this)} onLongPress={this.fastIncrement.bind(this)} onPressOut={this.removeInterval.bind(this)}>
            <Ionicons
              name="md-add-outline"
              size={20}
              color={"#000000"}
            />
          </Pressable>
          <Pressable style={styles.addminusButton} onPress={this.decrement.bind(this)} onLongPress={this.fastDecrement.bind(this)} onPressOut={this.removeInterval.bind(this)}>
            <Ionicons
              name="md-remove-outline"
              size={20}
              color={"#000000"}
            />
          </Pressable>
          <Pressable style={styles.addminusButton} onPress={this.remove.bind(this)}>
            <Ionicons
              name="md-close-outline"
              size={20}
              color={"#000000"}
            />
          </Pressable>
          </View>
      }
    }

	/*
	        <Animated.View style={[styles.actionProgress,
        {width: this.progressInterpolate}
      ]}>
        </Animated.View>
		*/
    return (
      <Pressable style={rowStyle} onPress={this.updateCodeIndex.bind(this)} onLongPress={this.overlayInfo.bind(this)}>
        <ProgressBar style={progressStyle} ref={this.progressRef} start={0}/>
        <Image style={styles.logo} source={TaskImages[this.props.task.action.image]} />
        <TextReader text={this.countText} ref={this.countRef}/>
        <Text style={styles.actionName} adjustsFontSizeToFit={true} numberOfLines={1}> {this.name}</Text>
        {addminus}
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    height: '100%',
    alignItems: 'center',
    width: '100%',
  },
  highlightrow: {
    flexDirection: "row",
    height: '100%',
    alignItems: 'center',
    width: '100%',
    borderTopWidth: 4,
    borderBottomWidth: 4,
    marginBottom: 20,
    borderColor: '#f44336',
  },
  buttonrow: {
    flexDirection: "row",
    height: '100%',
    flex: 1,
    justifyContent: 'flex-end',
    alignContent: 'center',
  },
  actionProgress: {
    backgroundColor: '#f44336',
    top: 0,
    height: 38,
    position: 'absolute',
    zIndex: -1,
  },
  altActionProgress: {
    backgroundColor: '#f44336',
    top: -4,
    height: 38,
    position: 'absolute',
    zIndex: -1,
  },
  actionNumber: {
    fontSize: 20,
    fontFamily: 'Alegreya-Regular',
    color: '#000000',
    minWidth: 50,
    textAlign: 'center',
  },
  actionName: {
    fontSize: 20,
    fontFamily: 'Alegreya-Regular',
    color: '#000000',
    flex: 1,
  },
  addminusButton: {
    marginLeft: 0,
    marginRight: 4,
    borderLeftWidth: 2,
    paddingLeft: 4,
    justifyContent: 'center',
  },
  logo: {
    margin: 5,
    height: 25,
    width: 25,
  },  
});

export default ActionRow;